module.exports = __webpack_public_path__ + "static/sc-01-fa2a163af78afce936fa6bd0b21bf351.png";